/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import { Application } from "@superwall/db"
import getApplication from "../queries/getApplication"
import { useQuery } from "@blitzjs/rpc"
import { SIcon } from "@superwall-me/sui"
import { useApplicationSetting } from "app/core/hooks/useApplicationSetting"

const ApplicationIcon = ({
  application,
  applicationId,
  size,
  showPlatform = false,
  ...props
}: {
  application?: Partial<Application> & Pick<Application, "name">
  size?: number
  applicationId?: number
  className?: string
  showPlatform?: boolean
}) => {
  const { width, height }: { width: number; height: number } = {
    ...{
      height: 40,
      width: 40,
    },
    ...(size ? { width: size, height: size } : {}),
  }

  // random id
  const id = Math.random().toString(36).substring(7)

  const [fetchedApplication] = useQuery(getApplication, { id: applicationId }, { suspense: false })

  const { data: stripeApplicationIcon } = useApplicationSetting(
    application?.id || applicationId!,
    "application_icon",
    {
      enabled: application?.platform === "STRIPE" || fetchedApplication?.platform === "STRIPE",
    }
  )

  const { className } = props

  // Get platform, appId and name with proper fallbacks
  const platform =
    (application?.platform?.toLowerCase() === "stripe"
      ? "unknown"
      : application?.platform?.toLowerCase()) || "unknown"

  const appId =
    application?.appId ||
    fetchedApplication?.appId ||
    application?.name ||
    fetchedApplication?.name ||
    "default"

  const name = application?.name || fetchedApplication?.name || ""

  // Properly encode URL parameters
  const encodedAppId = encodeURIComponent(appId)
  const encodedName = encodeURIComponent(name)

  // Construct the icon URL
  const defaultIconUrl = `https://app-icons.superwall.com/${platform}/icon/${encodedAppId}?height=200&width=200&name=${encodedName}&a=b`

  const iconUrl =
    application?.platform === "STRIPE" || fetchedApplication?.platform === "STRIPE"
      ? stripeApplicationIcon ?? defaultIconUrl
      : defaultIconUrl

  return (
    <>
      <div className={`flex relative ${className}`}>
        <span style={{ transform: "scale(1.04)", opacity: "1" }}>
          <svg className="iOS-svg" width={width} height={height} viewBox="0 0 200 200">
            <path
              d="M100,200c43.8,0,68.2,0,84.1-15.9C200,168.2,200,143.8,200,100s0-68.2-15.9-84.1C168.2,0,143.8,0,100,0S31.8,0,15.9,15.9C0,31.8,0,56.2,0,100s0,68.2,15.9,84.1C31.8,200,56.2,200,100,200z"
              fill="#23272E"
            />
          </svg>
        </span>
        <span className="absolute">
          <svg className="iOS-svg" width={width} height={height} viewBox="0 0 200 200">
            <defs>
              <pattern id={`squircle-${id}`} patternUnits="userSpaceOnUse" width="200" height="200">
                <image xlinkHref={iconUrl} x="0" y="0" width="200" height="200" />
              </pattern>
            </defs>

            <path
              d="M100,200c43.8,0,68.2,0,84.1-15.9C200,168.2,200,143.8,200,100s0-68.2-15.9-84.1C168.2,0,143.8,0,100,0S31.8,0,15.9,15.9C0,31.8,0,56.2,0,100s0,68.2,15.9,84.1C31.8,200,56.2,200,100,200z"
              fill={`url(#squircle-${id})`}
            />
          </svg>
        </span>
        {showPlatform && (
          <span
            className="absolute rounded-md border border-white/7 bg-grayscale-dark shadow-xl"
            style={{
              right: `${(6 / 40) * Math.min(36, width) * -1}px`,
              bottom: `${(6 / 40) * Math.min(36, width) * -1 + 1}px`,
              width: `${(25 / 40) * Math.min(36, width)}px`,
              height: `${(25 / 40) * Math.min(36, width)}px`,
            }}
          >
            <span className="absolute inset-0 flex items-center justify-center">
              {application?.platform?.toLowerCase() === "android" ? (
                // <AndroidIcon className="fill-white/[0.85]" />
                <SIcon
                  type="android"
                  size={(15 / 40) * Math.min(36, width)}
                  className="fill-white/[0.85]"
                />
              ) : application?.platform?.toLowerCase() === "stripe" ? (
                <SIcon
                  type="stripe"
                  size={(15 / 40) * Math.min(36, width)}
                  className="grayscale brightness-[1000] opacity-[0.85]"
                />
              ) : (
                <SIcon
                  type="apple"
                  size={(15 / 40) * Math.min(36, width)}
                  className="fill-white/[0.85]"
                />
              )}
            </span>
          </span>
        )}
      </div>
    </>
  )
}
export default ApplicationIcon
